import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Global } from '../../Service/global.service';
import { PublicationService } from '../../Service/publications.services';
import { PublicationsService } from '../../Service/publications.service';
import { sp, Web } from "@pnp/sp/presets/all";
import { HttpClient } from '@angular/common/http';
declare var $;


@Component({
  selector: 'app-deposer-candidature',
  templateUrl: './deposer-candidature.component.html',
  styleUrls: ['./deposer-candidature.component.scss']
})
export class DeposerCandidatureComponent implements OnInit {

  form: any;

  constructor(
    public global: Global,
    private service: PublicationService,
    private publications: PublicationsService,
    private aroute: ActivatedRoute,
    private router: Router,
    private _formBuilder: FormBuilder,
    private ngZone: NgZone,
    private http: HttpClient
  ) {
    sp.setup({
      sp: {
        baseUrl: global._basedUrl,
      },
    });

  }
  @ViewChild('form1') form1: ElementRef;
  file;
  sending = false;
  lgsub;
  panelOpenState = false;
  routesub;
  currentUrl;
  outputLg;
  section;
  urlSection;
  currentlang
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  code;
  IdOffre;
  currenOffer;
  fileUploadUrl = '';
  isFileUploaded = 0;
  confirmationMessage  = '';
  TitlePoste = '';

  // V2 
  selectedFile: File | null = null;
  fileSizeError: boolean = false;
  filename: string = '';
  readonly maxFileSize = 15 * 1024 * 1024; // 15MB in bytes
  // end V2 
  ngOnInit(): void {
    this.confirmationMessage  = '';
    this.lgsub = this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {
      if (lg.code === 'fr') {
        this.aroute.params.subscribe(params => {
          this.IdOffre = params["Id"];
          this.service.getAppelOffreById(lg.url, this.IdOffre).subscribe(datas => {
            if (datas['value'].length > 0) {
              this.TitlePoste = datas['value'][0].Title;
              let delai = new Date(datas['value'][0].DelaiDepot);
             
              //@ts-ignore
              delai.addHours(1);
              delai = new Date(delai.toLocaleDateString("en"))
              const currentDate = new Date(new Date().toLocaleDateString("en"));
              if (currentDate > delai) {
                alert('Delai de depot depassé !');
                this.router.navigate(['/publications/offres-emplois']);
              }
              else if (datas['value'][0]["Annonce"] == "Externe") {
                alert('Offre d\'emploi externe !');
                this.router.navigate(['/publications/offres-emplois']);
              }
              else {
                this.currenOffer = datas['value'][0];
              }

            } else {
              alert('Offre introuvable !!');
              this.router.navigate(['/']);
            }
          })

        });
        this.outputLg = lg;
        this.currentlang = lg.url;
        this.currentUrl = this.router.url
        const url = this.router.url;

        this.currentUrl = this.router.url
        if (url.indexOf('/agence/') !== -1) {
          this.section = 'Agence';
          this.urlSection = '/agence/presentation'
        } else if (url.indexOf('/grands-chantiers/') !== -1) {
          this.section = 'Grands Chantiers';
          this.urlSection = '/grands-chantiers/chantiers-infrastructures'
        } else if (url.indexOf('/missions/') !== -1) {
          this.section = 'Missions';
          this.urlSection = '/missions/PortAuthorite'
        } else if (url.indexOf('/formation-portuaire/') !== -1) {
          this.section = 'Formation Portuaire';
          this.urlSection = '/formation-portuaire/ifp'
        } else if (url.indexOf('/services/') !== -1) {
          this.section = 'Services';
          this.urlSection = '/services/portnet'
        } else if (url.indexOf('/publications/') !== -1) {
          this.section = 'Publications';
          this.urlSection = '/publications/communiques-presse'
        } else if (url.indexOf('/espace-professionnel/') !== -1) {
          this.section = 'Espace Professionnel';
          this.urlSection = '/espace-professionnel/portnet'
        }
        setTimeout(() => {
          this.createCaptcha();
        }, 1500)
      } else {
        this.router.navigate(['/']);
      }

    });

    // $('#exampleModal').on('hidden.bs.modal', () => {
    //   this.ngZone.run(() => {
    //     this.isFileUploaded = -1;
    //   });

    //   Web(this.outputLg.url).lists.getByTitle('PreCandidatures').items.filter('Title  eq \'' + this.form.CIN + '\'').get().then(datas => {
    //     if (datas.length > 0) {
    //       this.ngZone.run(() => {
    //         this.isFileUploaded = 1;
    //       });
    //     } else {
    //       this.ngZone.run(() => {
    //         this.isFileUploaded = 0;
    //       });
    //     }
    //   }).catch((a) => {
    //     this.ngZone.run(() => {
    //       this.isFileUploaded = 0;
    //     });
    //   })
    // });

  }
  log(a){
    console.log(a);
  }

  createCaptcha() {

    //clear the contents of captcha div first 
    document.getElementById('captcha').innerHTML = "";
    let charsArray =
      "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let lengthOtp = 5;
    let captcha = [];
    for (let i = 0; i < lengthOtp; i++) {

      let index = Math.floor(Math.random() * charsArray.length + 1);
      if (captcha.indexOf(charsArray[index]) == -1)
        captcha.push(charsArray[index]);
      else i--;
    }
    let canv = document.createElement("canvas");
    canv.id = "captcha";
    canv.width = 90;
    canv.height = 40;
    let ctx = canv.getContext("2d");
    ctx.font = "23px Georgia";
    ctx.strokeText(captcha.join(""), 0, 30);
    //storing captcha so that can validate you can save it somewhere else according to your specific requirements
    this.code = captcha.join("");
    document.getElementById("captcha").appendChild(canv); // adds the canvas to the body element
  }
  validateCaptcha() {
    let result = false;

    //@ts-ignore
    if (document.getElementById("cpatchaTextBox").value == this.code) {
      result = true;
    } else {
      alert("Captcha invalid");
      this.createCaptcha();
    }
    return result
  }
  chargeIframe(form) {
    this.form = form.value;
    var iframe = document.getElementById('fileFrame') as HTMLIFrameElement;
    const TitleCandidature =  this.form1['value']['first']['CIN']
    //const TitleCandidature = this.currenOffer.Id + "-"+ this.form1['value']['first']['CIN']
    iframe.src = '/fra/SitePages/fileimport.aspx?fileName=' + TitleCandidature + '.zip&title=' + this.form1['value']['first']['CIN']+'&postId='+this.currenOffer["ID"]
  }

  
  uploadCanditature2(file, ngform) {
    this.confirmationMessage  = '';
    if (this.validateCaptcha()) {
      let form = ngform.value;
      this.ngZone.run(() => {
        this.sending = true;
      })
      //const TitleCandidature = this.currenOffer.Id + "-"+ form.CIN
      const TitleCandidature =  form.CIN
      Web(this.outputLg.url).lists.getByTitle('PreCandidatures').items.filter('Title  eq \'' + TitleCandidature + '\'').get()
        .then(datas => {
          if (datas.length > 0) {
            Web(this.outputLg.url).lists.getByTitle('PreCandidatures').items.getById(datas[0].Id).update({
              'PrenomCandidat': form.Prenom,
              'NomCandidat': form.Nom,
              DateNaissance: new Date(form.DateNaissance),
              'Situation': form.Situation,
              'CIN': form.CIN,
              'WorkAddress': form.Addresse,
              'Telephone': form.Telephone,
              'TelephoneSec': form.TelephoneSecond,
              'Diplome': form.Diplome,
              'Specialite': form.Specialite,
              'Specialite2': form.Specialite2,
              'Ecole': form.Ecole,
              'AutreFormation': form.AutreFormation,
              'Employeur': form.Organisme,
              'Poste': form.Poste,
              'Secteur': form.Secteur,
              'StartDate': new Date(form.DateDebut),
              'DateFin': new Date(form.DateFin),
              'Experience': form.NbrExperience.toString(),
              'PosteIdId': this.currenOffer.Id,
              'NiveauEtudes': form.NiveauEtude,
              'Matricule': form.Matricule,
              'Region': this.currenOffer.RegionEmploi,
              'PosteName': this.currenOffer.Title,
              'Email':form.Email, 
              'StatutCandidature': 'Brouillon'
            })
              .then(updated => {
                this.http.get(this.global._basedUrl + "/assets/i18n/fr").subscribe(data => {
                  // this.http.post(this.global._basedUrl + "/_vti_bin/WS/Service.svc/email/send",
                  //   {
                  //     "to": form.Email,
                  //     "subject": data["mail"].subject+this.currenOffer["Title"],
                  //     "body": data["mail"].body.replace("{1}" , this.currenOffer["Title"])
                  //   }
                  // ).subscribe((datas) => { /*console.log(datas)*/ });
                })
                
                this.ngZone.run(() => {
                  this.sending = false;
                })
            
                this.confirmationMessage  = 'Succes';
                // setTimeout(() => {
                //   this.router.navigate(['/']);
                // },5000);
            
              })
              .catch(() => {
                this.ngZone.run(() => {
                  this.sending = false;
                })
                
                this.confirmationMessage  = 'Erreur';
                // setTimeout(() => {
                //   this.router.navigate(['/']);
                // },5000);
              })
          } else {
            this.ngZone.run(() => {
              this.sending = false;
            })
            alert("Merci d\'ajouter le dossier de candidature");
          }
        })
        .catch(() => {
          this.ngZone.run(() => {
            this.sending = false;
          })
          alert("erreur lors de l'ajout du candidature");
        })

    }

  }
  mergeForm(ngform){
    let result={value:{}}
    result.value =Object.assign(ngform.value.first,ngform.value.second);
    return result;
  }

// V2 

onFileSelected(event: Event) {
  const input = event.target as HTMLInputElement;
  if (input.files && input.files.length > 0) {
    const file = input.files[0];

    // Check file size
    if (file.size > this.maxFileSize) {
      this.fileSizeError = true;
      this.selectedFile = null;
    } else {
      this.selectedFile = file;
      this.fileSizeError = false;

    }
  }
}

uploadCanditature(ngform) {
  this.confirmationMessage = '';
  if (!this.validateCaptcha()) return;

  const form = ngform.value;
  //const TitleCandidature = form.CIN;
  const TitleCandidature = this.currenOffer.Id + "-"+ form.CIN
  this.filename = TitleCandidature + '.zip';
  this.ngZone.run(() => { this.sending = true; });

  const candidatureData = {
    'PrenomCandidat': form.Prenom,
    'NomCandidat': form.Nom,
    'DateNaissance': new Date(form.DateNaissance),
    'Situation': form.Situation,
    'CIN': form.CIN,
    'WorkAddress': form.Addresse,
    'Telephone': form.Telephone,
    'TelephoneSec': form.TelephoneSecond,
    'Diplome': form.Diplome,
    'Specialite': form.Specialite,
    'Specialite2': form.Specialite2,
    'Ecole': form.Ecole,
    'AutreFormation': form.AutreFormation,
    'Employeur': form.Organisme,
    'Poste': form.Poste,
    'Secteur': form.Secteur,
    'StartDate': new Date(form.DateDebut),
    'DateFin': new Date(form.DateFin),
    'Experience': form.NbrExperience.toString(),
    'PosteIdId': this.currenOffer.Id,
    'NiveauEtudes': form.NiveauEtude,
    'Matricule': form.Matricule,
    'Region': this.currenOffer.RegionEmploi,
    'PosteName': this.currenOffer.Title,
    'Email': form.Email,
    'StatutCandidature': 'Brouillon'
  };
if (this.selectedFile) {
  Web(this.outputLg.url).lists.getByTitle('PreCandidatures').items
    .filter(`Title eq '${TitleCandidature}'`).get()
    .then(datas => {
      if (datas.length > 0) {
        return Web(this.outputLg.url).lists.getByTitle('PreCandidatures').items
          .getById(datas[0].Id).update(candidatureData)
          .then(() => this.attachFileToItem(datas[0].Id, this.selectedFile));
      } else {
        return Web(this.outputLg.url).lists.getByTitle('PreCandidatures').items
          .add({ 'Title': TitleCandidature, ...candidatureData })
          .then(newItem => this.attachFileToItem(newItem.data.Id, this.selectedFile));
      }
    })
    .catch(error => {
      console.error("Error processing candidature:", error);
      this.confirmationMessage = 'Erreur lors du traitement de la candidature';
    })
    .finally(() => {
      this.ngZone.run(() => { this.sending = false; });
    });
  }
  else{
    alert("Erreur lors de l'ajout du fichier. Merci de réessayer.");
   // this.confirmationMessage = "Erreur lors de l'ajout du fichier. Merci de réessayer";
   this.sending = false;

  }
}




// attachFileToItem(itemId, file) {
//   if (!file) {
//     console.warn("No file provided for attachment.");
//     return;
//   }

//   Web(this.outputLg.url).lists.getByTitle('PreCandidatures').items
//     .getById(itemId).attachmentFiles.add(this.filename, file)
//     .then(() => {
//       console.log("File attached successfully.");
//       this.confirmationMessage = "Succes"
//       this.ngZone.run(() => {
//         this.sending = false;
//       });
//       this.confirmationMessage = 'Succes';
//     })
//     .catch(error => {
//       console.error("Error attaching file:", error);
//       this.ngZone.run(() => {
//         this.sending = false;
//       });
//       alert("Erreur lors de l'ajout du fichier.");
//     });
// }


// digest methode
// attachFileToItem(itemId, file) {
//   if (!file) {
//     console.warn("No file provided for attachment.");
//     return;
//   }

//   // Step 1: Get Request Digest
//   this.publications.getRequestDigest().subscribe(
//     (response: any) => {
//       const digestValue = response.FormDigestValue;

//       // Step 2: Read File as Binary
//       const reader = new FileReader();
//       reader.onload = () => {
//         const fileData = reader.result as ArrayBuffer;

//         // Step 3: Upload File using HTTP POST
//         const url = `${this.global._basedUrl}${this.global._FrUrl}/_api/web/lists/getbytitle('PreCandidatures')/items(${itemId})/AttachmentFiles/add(FileName='${this.filename}')`;

//         this.http.post(url, fileData, {
//           headers: {
//             "Accept": "application/json;odata=verbose",
//             "X-RequestDigest": digestValue
            
//           }
//         }).subscribe(
//           () => {
//             console.log("File attached successfully.", digestValue);
//             this.ngZone.run(() => {
//               this.sending = false;
//             });
//             this.confirmationMessage = "Succes";
//           },
//           error => {
//             console.error("Error attaching file:", error);
//             this.ngZone.run(() => {
//               this.sending = false;
//             });
//             alert("Erreur lors de l'ajout du fichier.");
//           }
//         );
//       };

//       reader.readAsArrayBuffer(file); // Read file content
//     },
//     error => {
//       console.error("Error getting request digest:", error);
//       alert("Erreur lors de l'obtention du jeton de sécurité.");
//     }
//   );
// }

attachFileToItem(itemId, file) {
  if (!file) {
    console.warn("No file provided for attachment.");
    return;
  }

  const formData = new FormData();
  formData.append("fileStream", file, file.name);

  const url = `${this.global._basedUrl}/_vti_bin/WS/Service.svc/uploadToSharePoint?itemId=${itemId}&fileName=${this.filename}`;

  this.http.post(url, formData).subscribe(
    (response) => {
      console.log("File uploaded successfully:", response);
      this.confirmationMessage = "Succes";
    },
    (error) => {
      console.error("Error uploading file:", error);
    }
  );
}


}
